import { Platform, View } from "react-native";
import variables from "../../styles/variables";
import RText from "../RText";

const NotificationBubble = ({
  count,
  onTabBar = false,
  onTabLabel = false,
}: {
  count: number;
  onTabBar?: boolean;
  onTabLabel?: boolean;
}) => {
  return (
    <View
      style={[
        {
          position: "absolute",
          justifyContent: "center",
          alignItems: "center",
          marginRight: variables.spacing.small,
          backgroundColor: variables.colors.palette.rtv.tertiary,
          width: count > 99 ? 30 : count > 9 ? 25 : 20,
          borderRadius: 25,

          height: 20,
          top: -10,
          right: -30,
          marginBottom: 15,
        },
        onTabBar && {
          position: "absolute",
          top: 0,
          right: Platform.OS == "web" ? -3 : -5,
        },
        onTabLabel && {
          top: 0,
          right: 0,
          marginBottom: 0,
          marginRight: 0,
        },
        onTabLabel &&
          Platform.OS != "web" && {
            position: "relative",
            marginBottom: 10,
          },
        onTabLabel &&
          Platform.OS == "web" && {
            right: 10,
          },
      ]}
    >
      <RText
        color="white"
        weight="bold"
        style={{ position: "absolute" }}
        size={count > 99 ? "sm" : "sm"}
        lineHeight={21}
      >
        {count > 99 ? "99+" : count}
      </RText>
    </View>
  );
};

export default NotificationBubble;
